export const successChartColors = {
  gridline: "rgba(0,0,0,0.06)",
  emptyBar: "rgba(0,0,0,0.06)",
  chartOverlay: "rgba(255,255,255,0.6)",
} as const;
